import React from 'react';
import { Switch, Tooltip } from '@mui/material';
import { useFormikContext } from 'formik';

/**
 * A setting of a form field config row as a switch. Changing it sets getValues(checked) — the
 * settings it changes, e.g. { mandatory, visible } — on that row in the form; the footer saves
 * them. disabledReason is shown while disabled. A shared row follows its original and can't
 * be edited, so its switches are always disabled.
 */
export const FormFieldConfigSwitchCell = ({
	config,
	label,
	checked,
	disabled: isRuleDisabled = false,
	disabledReason = '',
	getValues,
}) => {
	const { setFieldValue } = useFormikContext();
	const isShared = Boolean(config.sharedFrom);
	const disabled = isShared || isRuleDisabled;

	const handleChange = (event) =>
		Object.entries(getValues(event.target.checked)).forEach(([field, value]) =>
			setFieldValue(`${config.id}.${field}`, value),
		);

	return (
		<Tooltip
			title={
				isShared
					? 'Shared from another broker group. Break the link (Owner column) to edit it.'
					: disabled && disabledReason
			}
		>
			{/* The span keeps the tooltip working while the switch is disabled */}
			<span>
				<Switch
					size='small'
					checked={Boolean(checked)}
					onChange={handleChange}
					onClick={(event) => event.stopPropagation()}
					disabled={disabled}
					slotProps={{ input: { 'aria-label': `${config.name} ${label}` } }}
				/>
			</span>
		</Tooltip>
	);
};

FormFieldConfigSwitchCell.displayName = 'FormFieldConfigSwitchCell';
